import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualCentroCusto from '../../actions/centro-custo/determinarPaginaAtualCentroCusto'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoCentroCusto extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualCentroCusto}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualCentroCusto,
    total: state.centroCusto.totalCentroCusto,
    registrosPorPagina: state.registrosPorPaginaCentroCusto
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualCentroCusto }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoCentroCusto)
